<template>
    <div>

         <CustomModal v-if="isModalOpen" ref="customModal" :modalId="modalId" :isOpen="isModalOpen" :showFooter="true" @modalClosed="modalClosed" :isStyle="'max-width:100% !important;'">
            
            <template #header>
                <h5 class="modal-title">{{['create','transfer'].includes(action) ? $t('create_purchase') : $t('edit_purchase') }}</h5>
                <button type="button" id="close-modal-btn" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="modalClosed"></button>
            </template>

            <template #body>
                <div style="text-align:left">
                        <div class="row">
                            <div class="col-6 col-sm-6">
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1"  class="form-label">{{$t('reference')}}</label>
                                    <input v-model="localData.reference" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Reference">
                                </div>
                            </div>
                            <div class="col-6 col-sm-6">
                                <div class="mb-3">
                                <label for="exampleFormControlInput1" class="form-label">{{$t('date')}}</label>
                                <input v-model="localData.date" type="date" class="form-control" id="exampleFormControlInput1" placeholder="Reference Date">
                            </div>
                            </div>
                        </div>

                        <hr>
                        <div class="mb-3">
                            <div class="">
                            <div v-for="(prd,i) in localData.products" :key="i" class="row mb-3">
                                <!-- Product selector: full width on mobile, compact on sm+ -->
                                <div class="col-12 col-xl-5">

                                <label for="paymentToggle" class="form-label toggle-label me-3">{{ $t('existing_product') }}</label>
                                <auto-complete  
                                        :uid="i"
                                        v-if="!localData.products[i].custom_product" 
                                        @emitAutoComplete="emitAutoComplete" 
                                        :defaultValue="localData.products[i].product_label" 
                                        entity="inventories"
                                        emitEvent="emitAutoComplete"
                                        :dislaySuggestions="action =='create' ? true : false " 
                                    ></auto-complete>
                                    <product-rich-text-editor
                                        v-if="localData.products[i].custom_product"
                                        v-model="localData.products[i].product_label"
                                        :placeholder="$t('product_label')"
                                    ></product-rich-text-editor>
   
                                </div>
                                <!-- Unit Cost -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('unit_cost')}}</label>
                                    <input v-model="localData.products[i].purchase_price" @focus="handleInputFocus(localData.products[i], 'purchase_price')" @blur="handleInputBlur(localData.products[i], 'purchase_price', i)" @change="calculatePrices" class="form-control" placeholder="Cost" type="number">
                                </div>
                                <!-- Qty -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('qty')}}</label> 
                                    <select v-if="!localData.products[i].custom_quantity_mode" class="form-select" :value="Number(localData.products[i].quantity)" @change="onQuantityChange(i, $event)">
                                        <option :value="0">0</option>
                                        <option :value="1">1</option>
                                        <option :value="2">2</option>
                                        <option :value="3">3</option>
                                        <option :value="4">4</option>
                                        <option :value="5">5</option>
                                        <option :value="6">6</option>
                                        <option :value="7">7</option>
                                        <option :value="8">8</option>
                                        <option :value="9">9</option>
                                        <option :value="10">10</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model="localData.products[i].quantity" @focus="handleInputFocus(localData.products[i], 'quantity')" @blur="handleInputBlur(localData.products[i], 'quantity', i)" @change="calculatePrices" class="form-control" min="0" type="number" step="any" inputmode="decimal" >
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                 <!-- VAT -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('vat')}} %</label>
                                    <select v-if="!localData.products[i].custom_vat_mode" class="form-select" :value="Number(localData.products[i].vat)" @change="onVatChange(i, $event)">
                                        <option :value="0">0%</option>
                                        <option :value="5">5%</option>
                                        <option :value="10">10%</option>
                                        <option :value="20">20%</option>
                                        <option :value="30">30%</option>
                                        <option value="custom">Custom</option>
                                    </select>
                                    <div v-else class="input-group">
                                        <input v-model.number="localData.products[i].vat" @focus="handleInputFocus(localData.products[i], 'vat')" @blur="handleInputBlur(localData.products[i], 'vat', i)" @change="calculatePrices" class="form-control" min="0" max="100" type="number" step="0.01" inputmode="decimal" pattern="[0-9]+(\.[0-9]{1,2})?" >
                                        <button class="btn btn-outline-secondary" type="button" @click="switchToVatSelectMode(i)" style="padding: 0 5px;">
                                            <AppIcon name="bi-list" class="bi bi-list" />
                                        </button>
                                    </div>
                                </div>
                                <!-- Total -->
                                <div class="col-4 col-xl-1" v-if="localData.products[i].product_id || localData.products[i].custom_product == true">
                                    <label for="exampleFormControlInput1" class="form-label">{{$t('total')}}: </label>
                                    <input v-model="localData.products[i].sub_total" @focus="handleInputFocus(localData.products[i], 'sub_total')" @blur="handleInputBlur(localData.products[i], 'sub_total', i)" class="form-control" min="0" type="number" step="0.01" inputmode="decimal"  >
                                </div>
                                <!-- Remove button -->
                                <div class="col-12 col-xl-1"  style="margin-top:25px">
                                    <button type="button" class="mb-3 btn line-item-delete-button" :aria-label="$t('delete')" :title="$t('delete')" @click="removeRow(i)"><AppIcon name="bi-trash" class="bi bi-trash" /></button>
                                </div>

                            </div>  
                            </div>

                            <div class="row">
                                <div class="col-sm-9 btn-add-product">
                                    <button type="button" class="mb-3 btn btn-success" @click="addNewRow"><PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" /> {{$t('product')}}</button>
                                
                                    <!-- <div style="color: #303030;padding: 5px;font-weight: bold;font-size: 12px;cursor: pointer;" @click="openCreateProductModal">{{$t('create_new_product')}}</div> -->
                                </div>
                                <div class="col-sm-3 d-none d-sm-block" v-if="checkIfValidProduct()">
                                    {{$t('sub_total')}} : <b>{{formatMoney(sub_total)}} </b> <br>
                                    {{$t('total')}} : <b>{{formatMoney(total)}} </b>
                                </div>
                            </div>
                            
                        </div>

                        <hr>
                        <div class="row">
                            <div class="col-sm-3">
                            <label for="exampleFormControlInput1" class="form-label">{{$t('supplier')}}</label>
                            <auto-complete  
                                    v-if="createSupplierState === false" 
                                    @emitAutoCompleteSupplier="emitAutoCompleteSupplier" 
                                    :defaultValue="localData?.supplier?.name"
                                    entity="suppliers"
                                    emitEvent="emitAutoCompleteSupplier"
                                ></auto-complete>
                            <a href="#" class="related-create-link d-block mt-1 small text-decoration-none" @click.prevent="openCreateSupplierModal">
                                <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('create_new_supplier')}}
                            </a>
                        </div>
                         <div class="col-sm-2">
                                    <label for="exampleFormControlInput1" class="form-label">
                                        {{$t('status')}}
                                    </label>
                                    <select v-model="localData.status" class="form-select" aria-label="Default select example">
                                        <option value="draft">{{$t('draft')}}</option>
                                        <option selected value="pending">{{$t('pending')}}</option>
                                        <option value="confirmed">{{$t('confirmed')}}</option>
                                    </select>
                        </div>
                        </div>
                        

                        <div class="mb-3">
                            <collapsible-notes-field v-model="localData.notes" id="purchase-notes" rows="1" />
                        </div>

                        <div class="mb-3"></div>

                    </div>
                    <div class="alert alert-warning" role="alert" v-if="msgError">
                        {{msgError}}
                    </div>
            </template>

            <template #footer>
                <!-- Mobile totals in footer -->
                <div class="mobile-totals d-block d-sm-none text-start me-auto" v-if="checkIfValidProduct()">
                    <div><small>{{$t('sub_total')}}:</small> <b>{{ formatMoney(sub_total) }}</b></div>
                    <div><small>{{$t('total')}}:</small> <b>{{ formatMoney(total) }}</b></div>
                </div>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                <button v-if="action == 'update'" type="button" class="btn btn-success" @click="updateRow" :disabled="!checkIfValidProduct() || loading">
                    <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                    {{$t('edit')}}</button>
                <button v-if="['create','transfer'].includes(action)" type="button" class="btn btn-success" @click="saveRow" :disabled="!checkIfValidProduct() || loading"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
            </template>

        </CustomModal>


        <add-supplier v-if="createSupplierState" :state="createSupplierState" @createSupplier="createSupplier"/>
        
        <add-product v-if="createProductState" :state="createProductState" />
        
        <!-- invoice modal -->
        <invoice-template-modal 
            v-if="invoiceModalisOpen" 
            @modalClosed="invoiceModalisOpen = false" 
            modalId="invoice-purchase-modal-22" 
            :isModalOpen="invoiceModalisOpen"  
            :data="localData" 
            type="purchase">
        </invoice-template-modal>
        <!-- invoice modal -->

    </div>
   
    
    
</template>

<script>
import CustomModal from '../CustomModal.vue'
import helper from '../../helper'
import AutoComplete from '../autocomplete/AutoComplete'
import AddSupplier from '../AddSupplier.vue'
import AddProduct from '../AddProduct.vue'
import InvoiceTemplateModal from '../invoiceLayout/InvoiceTemplateModal.vue'
import ProductRichTextEditor from '../common/ProductRichTextEditor.vue'
import moment from 'moment'
export default {
  name: 'AddEditQuoteModal',
  props : {
        action: {
            type: String,
            required: true
        },
        data: {
            default: false
        },
        isModalOpen: {
            type: Boolean,
            default: false
        },
        modalId : {
            type : String,
            default : 'exampleModal'
        }
    },
  components : {
    CustomModal,
    AutoComplete,
    AddSupplier,
    AddProduct,
    InvoiceTemplateModal,
    ProductRichTextEditor
  },
  data(){
    return {
        loading : false,
        invoiceModalStatus : false,
        invoiceModalisOpen :false,
        createSupplierState : false,
        createProductState : false,
        hideSupplier : false,
        localData: JSON.parse(JSON.stringify(this.data)),
        msgError : null
    }
  },
   mounted(){
    if(this.isDetailClient && this.isDetailClient == true){
        this.hideSupplier = true
    }

  },
 
  computed : {
    business(){ return this.$store.getters.BUSINESS},
    total(){ return this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.localData.products.length ? this.localData.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0},
  },
  methods : {
    async saveRow(){
        try{
            this.loading = true
            this.sanitizeCustomProductLabels()

            //format products
            this.localData.products = helper.formatProducts(this.localData.products)
            if(!this.localData.supplier_id && this.localData.supplier && this.localData.supplier.id ){
                this.localData.supplier_id = this.localData.supplier.id
            }
            
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(this.localData.products[i].quantity == 0){
                    this.msgError += `${this.$t('product')}: [${helper.richTextToPlainText(this.localData.products[i].product_label)}] ${this.$t('quantity')} :[${this.localData.products[i].quantity}] \n`
                }
            }

            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError !== null) {
                this.loading = false
                return
            }
            
            // Update the existing draft instead of creating a new one
            const response = await helper.customPatch(`${process.env.VUE_APP_API}/purchases/${this.localData.id}`,{...this.localData },{showToast:true})
            this.clearForm()
            this.loading = false
            this.modalClosed()
            this.$router.push({path : `/purchases/${response.data.id}`})
        }catch(error){
            this.loading = false
        }
    },
    async updateRow(){
        try{
            this.loading = true
            this.sanitizeCustomProductLabels()

            //format products
            this.localData.products = helper.formatProducts(this.localData.products)
            if(!this.localData.supplier_id && this.localData.supplier && this.localData.supplier.id ){
                this.localData.supplier_id = this.localData.supplier.id
            }
            
            for(let i = 0 ; i < this.localData.products.length ; i++){
                if(this.localData.products[i].quantity == 0){
                    this.msgError += `${this.$t('product')}: [${helper.richTextToPlainText(this.localData.products[i].product_label)}] ${this.$t('quantity')} :[${this.localData.products[i].quantity}] \n`
                }
            }

            if(!this.localData.products.length){
                this.msgError = `No Product Found`
            }

            if(this.msgError !== null) {
                this.loading = false
                return
            }
            await helper.customPatch(`${process.env.VUE_APP_API}/purchases/${this.localData.id}`,{...this.localData })
            this.loading = false
            this.clearForm()
            this.modalClosed()
            this.$emit('refresh',true)
        }catch(error){
            this.loading = false
        }
    },
    clearForm(){
        this.localData = {
            id : null,
            reference : '',
            client_id : null,
            client : {},
            date : '',
            total : 0,
            products : []
        }

    },
    addNewRow(){
        this.localData.products.push({
            id : null,
            label : '',
            quantity : 0,
            price : 0,
            discount : 0,
            vat :  0,
            total : 0,
            sub_total : 0,
            custom_product : false,
            custom_quantity_mode : false,
            custom_vat_mode : false
        })
    },
    removeRow(i){
       this.localData.products.splice(i, 1);
    },
    onQuantityChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_quantity_mode = true;
        } else {
            this.localData.products[index].custom_quantity_mode = false;
            this.localData.products[index].quantity = Number(val);
            this.calculatePrices();
        }
    },
    switchToSelectMode(index) {
        this.localData.products[index].custom_quantity_mode = false;
        this.localData.products[index].quantity = 0;
        this.calculatePrices();
    },
    onVatChange(index, event) {
        const val = event.target.value;
        if (val === 'custom') {
            this.localData.products[index].custom_vat_mode = true;
        } else {
            this.localData.products[index].custom_vat_mode = false;
            this.localData.products[index].vat = Number(val);
            this.calculatePrices();
        }
    },
    switchToVatSelectMode(index) {
        this.localData.products[index].custom_vat_mode = false;
        this.localData.products[index].vat = 0;
        this.calculatePrices();
    },
    handleInputFocus(row, field){
        if(row[field] == 0){
            row[field] = ''
        }
    },
    handleInputBlur(row, field){
        if(row[field] === '' || row[field] === null || row[field] === undefined){
            row[field] = 0
            if(field === 'sub_total'){
                // For purchase, total is sub_total in the input (based on template label)
                // But wait, the template says "Total" label but binds to "sub_total"
                // And there is no parseTTctoHt call in the original template for this input
                // Let's check the original template again.
                // Line 66: <input v-model="localData.products[i].sub_total" class="form-control" min="0" type="number" step="0.01" inputmode="decimal"  >
                // It doesn't call parseTTctoHt.
                // However, there is a parseTTctoHt method in the script (lines 331-336).
                // It seems unused in the template?
                // Let's look at the original file content again.
                // Yes, line 66 has no @change or @blur calling parseTTctoHt.
                // But I should probably add it if I want the reverse calculation to work properly on blur/change?
                // The user asked to "copy the same logic".
                // In Quote/Invoice/Order, the total input calls parseTTctoHt.
                // Here, "Total" input binds to sub_total.
                // Let's assume I should just recalculate prices if it's not the total field.
                // If it is sub_total, maybe I should call parseTTctoHt?
                // Let's stick to what I see in other files:
                // In Invoice: Total input calls parseTTctoHt.
                // In Purchase: Total input binds to sub_total.
                // I will add the call to parseTTctoHt on change/blur for sub_total if that's what the "Total" label implies.
                // But wait, the parseTTctoHt in Purchase (lines 331-336) updates price and sub_total.
                // Let's use it.
                // But first, let's just implement the focus/blur logic.
                this.calculatePrices()
            }else if(['purchase_price','quantity','vat'].includes(field)){
                this.calculatePrices()
            }
        }
    },
    calculatePrices(){
        this.msgError = null
        this.$forceUpdate();
        for(let i = 0 ; i < this.localData.products.length ; i++){
            this.localData.products[i].total = parseFloat(this.localData.products[i].purchase_price) * parseFloat(this.localData.products[i].quantity)
            this.localData.products[i].sub_total = Math.round(parseFloat(this.localData.products[i].total))
            if(this.localData.products[i].vat > 0){
                this.localData.products[i].total += parseFloat((parseFloat(this.localData.products[i].total) * parseFloat(this.localData.products[i].vat/ 100)).toFixed(2))
                this.localData.products[i].total = Math.round(this.localData.products[i].total)
            }
        }
        this.localData.total = this.localData.products && this.localData.products.length ? this.localData.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;
    },
    parseTTctoHt(index,price){
        if(price === '') return
        if(price && price > 0){
           this.localData.products[index].price = ((price / this.localData.products[index].quantity) / 1.2).toFixed(2)
           this.localData.products[index].sub_total = parseFloat(this.localData.products[index].price) * parseFloat(this.localData.products[index].quantity)
        }
    },
    emitAutoComplete(data){
        if(!this.localData.products.length || !this.localData.products.find(product => product.product_id == data.result.product.id)){
            this.localData.products[data.index] = {
                ...{
                inventory_id : data.result.id,
                product_id : data.result.product.id,
                label : data.result.product.label,
                product_label : data.result.product.label,
                // id : data.result.product.id,
                quantity : 0,
                maxQty : data.result.quantity,
                price : data.result.price,
                unity : data.result.unity,
                purchase_price : data.result.purchase_price ? data.result.purchase_price : 0,
                vat :  0,
                total : data.result.total ? data.result.total : 0,
                sub_total : data.result.sub_total ? data.result.sub_total : 0,
                custom_product : false,
                custom_quantity_mode : false,
                custom_vat_mode : false
            }}
            this.localData.products = [...this.localData.products]
        }
    },
    emitAutoCompleteSupplier(data){
        this.localData.supplier_id = data.result.id
        this.localData.supplier = data.result
    },
    openCreateSupplierModal(){
        this.createSupplierState = !this.createSupplierState
    },
    createSupplier(data){
        if(data.supplier){
            this.localData.supplier_id = data.supplier.id
            this.localData.supplier = data.supplier
        }
        if(data && data.state != undefined){
            this.createSupplierState = data.state
        }
    },
    openCreateProductModal(){
        this.createProductState = !this.createProductState
    },
    createProduct(data){
        if(data.product){
            if(!this.localData.products.length || !this.localData.products.find(product => product.product_id == data.product.id)){
                this.localData.products.push({
                    inventory_id : data.inventory.id,
                    product_id : data.product.id,
                    label : data.product.label,
                    product_label : data.product.label,
                    quantity : 0,
                    maxQty : data.inventory.quantity,
                    price : data.inventory.price,
                    unity : data.inventory.unity,
                    purchase_price : data.inventory.purchase_price ? data.inventory.purchase_price : 0,
                    vat : 0,
                    total :  0,
                    sub_total : 0,
                    custom_product : false,
                    custom_quantity_mode : false,
                    custom_vat_mode : false
                })
            }

        }
        if(data && data.state != undefined){
            this.createProductState = data.state
        }
    },
    checkIfValidProduct(){
        return this.localData.products.length > 0 && this.localData.products.every(product => (
            product.product_id != null
            || (product.custom_product === true && helper.richTextToPlainText(product.product_label).trim().length > 0)
        ))
    },
    sanitizeCustomProductLabels(){
        this.localData.products.forEach(product => {
            if (product.custom_product) {
                product.product_label = helper.sanitizeRichText(product.product_label)
            }
        })
    },
    modalClosed(){
        this.isModalOpen = false 
        if(document.getElementById('close-modal-btn')){
            document.getElementById('close-modal-btn').click()
        }
        this.clearForm()
        this.$emit('modalClosed', true)
    },
    //helper functions
    formatDate(date,locale) { return helper.formatDate(date,locale) },
    formatMoney(number) { return helper.formatMoney(number);},
    formatReference(number,id) { return helper.formatReference(number,id);}
  },
  async created(){
    if(this.localData.date) {
        this.localData.date = moment(this.localData.date).format('YYYY-MM-DD')
    }else{
        this.localData.date = moment().format('YYYY-MM-DD')
    } 

    if(this.localData.products.length){
        for(let i = 0 ; i < this.localData.products.length ; i++){
            const q = Number(this.localData.products[i].quantity);
            this.localData.products[i].custom_quantity_mode = ![0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].includes(q);
            const v = Number(this.localData.products[i].vat);
            this.localData.products[i].custom_vat_mode = ![0, 5, 10, 20, 30].includes(v);
        }
    } 
 // When creating, immediately create a draft on the server and keep its id/reference
    if(['create','transfer'].includes(this.action)){
        const { data } = await helper.customPost(`${process.env.VUE_APP_API}/purchases/draft`,{})
        this.localData.id = data.id
        this.localData.reference = data.reference
        if(data.date){
            this.localData.date = moment(data.date).format('YYYY-MM-DD')
        }
    }
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
